import client from './client'
import type { MerchantSearchResult, CrowdMerchant, CrowdProduct } from '../types'

export interface MerchantSearchResponse {
  items: MerchantSearchResult[]
  total: number
}

export interface CreateMerchantData {
  shop_name: string
  phone?: string
  address?: string
  category?: string
  description?: string
  latitude?: number
  longitude?: number
}

export async function searchMerchants(
  q = '',
  skip = 0,
  limit = 15,
  lat?: number,
  lng?: number,
  category?: string,
): Promise<MerchantSearchResponse> {
  const res = await client.get('/v1/crowd/merchants/search', {
    params: {
      q,
      skip,
      limit,
      lat: lat ?? undefined,
      lng: lng ?? undefined,
      category: category || undefined,
    },
  })
  return res.data
}

export async function getRecentMerchants(
  lat?: number,
  lng?: number,
  limit = 5,
): Promise<MerchantSearchResponse> {
  const res = await client.get('/v1/crowd/merchants/recent', {
    params: {
      lat: lat ?? undefined,
      lng: lng ?? undefined,
      limit,
    },
  })
  return res.data
}

export async function createMerchant(data: CreateMerchantData): Promise<CrowdMerchant> {
  const res = await client.post('/v1/crowd/merchants/', data)
  return res.data
}

export async function getMerchant(merchantId: string): Promise<CrowdMerchant> {
  const res = await client.get(`/v1/crowd/merchants/${merchantId}`)
  return res.data
}

export async function getMerchantProducts(
  merchantId: string,
  skip = 0,
  limit = 20,
  search = '',
  categoryId?: string,
): Promise<{ items: CrowdProduct[]; total: number }> {
  const res = await client.get(`/v1/crowd/merchants/${merchantId}/products`, {
    params: { skip, limit, search: search || undefined, category_id: categoryId || undefined },
  })
  return res.data
}
